import moment from 'moment';
import { FC } from 'react';
import { CloseButton, DialogSubTitle, DialogToolbar } from '../../../../shared/dialog/dialog.styles';
import { withApptRequestIvStatusDialogProvider } from '../../hooks/use-appt-request-iv-status-dialog/hoc';
import { useApptRequestIvStatusDialog } from '../../hooks/use-appt-request-iv-status-dialog/hook';
import { ApptRequestIvStatusDialog } from '../appt-request-iv-status-dialog';
import { SelfPayButton } from '../shared/self-pay-button';
import { BoldText } from '../styles';

const ManuallyVerifiedDialog: FC = () => {
  const { opened, onClose, isLoading, ivSummary, appointmentRequest } = useApptRequestIvStatusDialog();

  return (
    <ApptRequestIvStatusDialog
      opened={opened}
      title={'Manually Verified'}
      subtitle={
        <>
          <BoldText>{`${appointmentRequest?.patient?.firstName} ${appointmentRequest?.patient?.lastName}`}</BoldText>
          {ivSummary?.dateSubmitted && <>&nbsp;- {moment.utc(ivSummary.dateSubmitted).local().format('MMM D hA')}</>}
        </>
      }
    >
      <DialogSubTitle sx={{ margin: '30px 0 20px 0', display: 'block' }}>
        This patient was manually verified by&nbsp;
        {ivSummary?.requestingUserFirstName}&nbsp;
        {ivSummary?.requestingUserLastName}.
      </DialogSubTitle>

      <DialogToolbar>
        <SelfPayButton onSuccess={async () => onClose()} disabled={isLoading} />
        <CloseButton onClick={onClose} disabled={isLoading} />
      </DialogToolbar>
    </ApptRequestIvStatusDialog>
  );
};

export default withApptRequestIvStatusDialogProvider(ManuallyVerifiedDialog);
